<template>

  <div>

    <div class="loading_page" v-if="requestPending">
      <orbit-spinner
          :animation-duration="1000"
          :size="30"
          :color="'#0e96b1'"
      />
    </div>

    <b-navbar-nav class="nav">

      <b-nav-item
          v-for="(bookmark, index) in bookmarks"
          :id="`bookmark-${index}`"
          :key="index"
          :to="bookmark.route"
      >
        <feather-icon
            :icon="bookmark.icon"
            size="21"
        />
        <b-tooltip
            triggers="hover"
            :target="`bookmark-${index}`"
            :title="$t(bookmark.title)"
            :delay="{ show: 100, hide: 50 }"
        />
      </b-nav-item>
      <b-nav-item-dropdown
          link-classes="bookmark-star"
          lazy
          @hidden="resetsearchQuery"
      >
        <feather-icon
            slot="button-content"
            icon="StarIcon"
            size="21"
            class="text-warning"
        />

        <!-- Dropdown Content -->
        <li style="min-width:300px">
          <div class="p-1">
            <b-form-input
                id="boomark-search-input"
                v-model="searchQuery"
                :placeholder="$t('Name')"
                autofocus
            />
          </div>

          <div class="loading_page" v-if="requestPending">
            <orbit-spinner
                :animation-duration="1000"
                :size="30"
                :color="'#0e96b1'"
            />
          </div>
          <vue-perfect-scrollbar
              :settings="perfectScrollbarSettings"
              class="search-list search-list-bookmark scroll-area"
              :class="{'show': filteredData && filteredData.length }"
              tagname="ul"
          >

            <b-dropdown-item
                v-for="(suggestion, index) in filteredData.data"
                :key="index"
                class="suggestion-group-suggestion cursor-pointer"
                link-class="d-flex align-items-center"
                :to="suggestion.route"
            >
              <feather-icon
                  :icon="suggestion.icon"
                  class="mr-75"
                  size="18"
              />
              <span class="align-middle">{{ suggestion.title }}</span>
              <feather-icon
                  icon="StarIcon"
                  class="ml-auto"
                  size="16"
                  :class="{'text-warning': suggestion.isBookmarked}"
                  @click.stop.prevent="toggleBookmarked(suggestion)"
              />

            </b-dropdown-item>
            <b-dropdown-item
                v-show="!(filteredData.data && filteredData.data.length) && searchQuery"
                disabled
            >
              {{ $t('BOOKMARKS_NO_RESULT')}}
            </b-dropdown-item></vue-perfect-scrollbar>
        </li>
      </b-nav-item-dropdown>

    </b-navbar-nav>

  </div>

</template>

<script>

import {
  BNavbarNav, 
  BNavItem, 
  BTooltip, 
  BNavItemDropdown, 
  BFormInput, 
  BDropdownItem
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { OrbitSpinner } from 'epic-spinners'
import useAutoSuggest from '@core/components/app-auto-suggest/useAutoSuggest'
import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import bookmarkData from '../search-and-bookmark-data'
import axios from '@/libs/axios'
import navMenuItems from '@/navigation/vertical'
import { checkAbility } from '@/libs/ability/routeProtection'

export default {
  components: {
    BNavbarNav, 
    BNavItem, 
    BTooltip, 
    BNavItemDropdown, 
    BFormInput, 
    VuePerfectScrollbar, 
    BDropdownItem,
    OrbitSpinner
  },
  setup(props,{root}) {

    const auth = store.state.auth.userData

    const requestPending = ref(false);

    const bookmarkables = ref([
          ...bookmarkData.pages.data, 
          ...navMenuItems.filter((item)=> 'children' in item)
              .map((item)=> item.children)
              .flat()
              .map((item)=> ({ title: item.title, route: { name: item.route }, icon: item.icon, isBookmarked: false }))
          ]
          .filter((item)=> checkAbility(item.route))
          .map((bookmarkable)=> {
            if(auth.settings.bookmarks.find((bookmark) => bookmark == bookmarkable.route.name)){
              bookmarkable.isBookmarked = true;
            }
            bookmarkable.title = root.$t(bookmarkable.title)
            return bookmarkable;
    }));

    const bookmarks = computed(()=> bookmarkables.value.filter((bookmarkable)=> bookmarkable.isBookmarked));

    const perfectScrollbarSettings = {
      maxScrollbarLength: 10,
    }

    const {
      searchQuery,
      filteredData,
      resetsearchQuery,
    } = useAutoSuggest({ data: { data:{key:'title', data:bookmarkables.value}}, searchLimit: 10 })

    watch(searchQuery, val => {
      store.commit('app/TOGGLE_OVERLAY', Boolean(val))
    })

    const toggleBookmarked = (suggestion) => {
     
     bookmarkables.value = bookmarkables.value.map((bookmarkable)=> {

       if(bookmarkable.route.name == suggestion.route.name){
         bookmarkable.isBookmarked = !bookmarkable.isBookmarked;
       }

       return bookmarkable

     })

     updateBookmarks(bookmarks.value.map((bookmark)=> bookmark.route.name))

   }

    const updateBookmarks = (bookmarks)=>{
        return new Promise((resolve, reject) => {
          requestPending.value = true
          axios.post('user/setBookmarks', {bookmarks})
              .then(res => {
                resolve(res.data)
              })
              .catch(reason => reject(reason.response))
              .finally(() => requestPending.value = false)
        })
    }

    return {
      requestPending,
      bookmarkables,
      bookmarks,
      perfectScrollbarSettings,
      searchQuery,
      filteredData,
      resetsearchQuery,
      toggleBookmarked,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';

ul
{
  list-style: none;
  padding: 0;
  margin: 0;
}
p {
  margin: 0;
}

.nav-bookmar-content-overlay {
    position: fixed;
    opacity: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-transition: all 0.7s;
    transition: all 0.7s;
    z-index: -1;

    &:not(.show) {
      pointer-events: none;
    }

    &.show {
      cursor: pointer;
      z-index: 10;
      opacity: 1;
    }
}
</style>
